const DEFAULT_CALENDAR_SLOT_DURATION = "00:15:00";

export const getCalendarSlotDuration = (value) => {
  if (typeof value !== "string") return DEFAULT_CALENDAR_SLOT_DURATION;
  const match = value.trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) return DEFAULT_CALENDAR_SLOT_DURATION;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  const seconds = Number(match[3] || 0);
  if (hours > 23 || minutes > 59 || seconds > 59 || hours + minutes + seconds === 0) {
    return DEFAULT_CALENDAR_SLOT_DURATION;
  }

  return [hours, minutes, seconds]
    .map(part => String(part).padStart(2, "0"))
    .join(":");
};


export const getCalendarSlotMinutes = (value) => {
  const [hours, minutes, seconds] = getCalendarSlotDuration(value).split(":").map(Number);
  const cadence = hours * 60 + minutes + seconds / 60;
  return Number.isInteger(cadence) ? cadence : 15;
};
